<template>
  <v-application v-if="access.item_discount">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="inventory count"
          :headers="headers"
          to="/items/promotions"
          :data="data"
          no-delete
          :num-pages="discount_total"
          v-model="discount_page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          :add_button_name="'add_dicount'"
          showSearch
          PromotionsItemsDiscount
          :search_text="search_text"
          :getData="Dicount_get"
          :searchActivate="
            (state) => {
              search_text = state;
            }
          "
          :setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-combobox
              v-model="store"
              label="Store"
              :items="stores"
              hide-details
              item-text="name"
              class="mx-1"
              outlined
              dense
            />
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
export default {
  name: "Stock",
  mixins: [Services],
  data: () => ({
    headers: [{ text: "name", value: "name" }],
    data: [],
    search_text: false,
    search: "",
    limit: 10,
    page: 1,
    discount_total: 0,
    data_loading: false,
    discount_page: 1,
  }),
  methods: {
    changePagination(page) {
      this.discount_page = page;
      this.Dicount_get();
    },
    async Dicount_get() {
      this.data_loading = true;
      const discount = this.$communicator.then(
        this,
        await this.$communicator("promotion_get", {
          arguments: [this.limit, this.discount_page],
          params: {
            service: this.store && this.store._id !== "" ? this.store._id : "",
            search: this.search,
          },
        })
      );
      this.data = discount?.data;
      this.discount_total = Math.ceil(discount?.total / this.limit);
      this.data_loading = false;
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", available: true },
      { text: this.$t("value"), value: "value", available: true },
      { text: this.$t("start_date"), value: "start_time", available: true },
      { text: this.$t("end_date"), value: "end_time", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.Dicount_get();
  },
  watch: {
    store: {
      deep: true,
      handler() {
        this.Dicount_get();
      },
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
